// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-footer_container__gieAr","top":"b2b-footer_top__Dkein","background":"b2b-footer_background__R5uNA"};